import ThumbContainer from './thumb_container';

const Thumb = ThumbContainer;
export default Thumb;
